import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();

  // Admin sayfalarında footer'ı gizle
  const isAdminPage = location.pathname.startsWith('/admin');

  // Admin sayfasında footer'ı gösterme
  if (isAdminPage) {
    return null;
  }

  return (
    <footer className="site-footer" aria-label="Site alt bilgisi">
      {/* Üst bölüm */}
      <div className="footer-top">
        {/* Sol: Latin Motto */}
        <div className="footer-col footer-col--left">
          <div className="footer-motto">
            <p className="footer-motto-latin">Lex est ratio summa</p>
            <p className="footer-motto-turkish">Kanun en yüksek akıldır</p>
          </div>
        </div>

        {/* Orta: Linkler */}
        <nav className="footer-col footer-col--center" aria-label="Alt menü">
          <ul className="footer-links">
            <li><Link to="/">Hakkımızda</Link></li>
            <li><Link to="/calisma-alanlarimiz">Çalışma Alanlarımız</Link></li>
            <li><Link to="/announcements">Duyurular</Link></li>
            {/* <li><Link to="/gallery">Galeri</Link></li> */}
            <li><Link to="/faq">SSS</Link></li>
          </ul>
        </nav>

        {/* Sağ: İletişim */}
        <div className="footer-col footer-col--right">
          <div><span className="label">Adres:</span> <span className="value value--bold">Necmettin Erbakan Mahallesi, Onur Sokak, NO:4, Daire: 15, Beşevler Rezidans, MERKEZ/KİLİS</span></div>
          <div><span className="label">Telefon:</span> <a className="value value--bold" href="tel:+905550857971">+90 555 085 79 71</a></div>
          <div><span className="label">E-posta:</span> <a className="value value--bold" href="mailto:sinansakitkaradas@gmail.com">sinansakitkaradas@gmail.com</a></div>
        </div>
      </div>

      {/* Alt çubuk */}
      <div className="footer-bottom">
        <small>
          © Tüm hakları saklıdır. Karadaş Hukuk Bürosu 2026.{' '}
          Made by{' '}
          <a
            href="https://www.linkedin.com/in/mehmet-sefa-karada%C5%9F-b93957246"
            target="_blank"
            rel="noopener noreferrer"
          >
            Mehmet Sefa Karadaş
          </a>
          .{' '}
          <Link to="/sitemap" className="footer-sitemap-link">
            Site Haritası
          </Link>
        </small>
      </div>
    </footer>
  );
};

export default Footer;
